import React from 'react';

const LoadingCircle = props => (
  <svg width={46} height={45} viewBox="0 0 46 45" {...props}>
    <path
      fill="none"
      strokeDasharray="94.248"
      strokeWidth="5"
      d="M24.1394071,44.7023591 C35.1851021,44.7023591 44.1394071,35.7480541 44.1394071,24.7023591 C44.1394071,13.6566641 35.1851021,4.7023591 24.1394071,4.7023591 C13.0937121,4.7023591 4.13940708,13.6566641 4.13940708,24.7023591 C4.13940708,35.7480541 13.0937121,44.7023591 24.1394071,44.7023591 Z"
      transform="rotate(-78 22.405 24.32)"
    />
  </svg>
);

export default LoadingCircle;
